import React from 'react';

import { Modal } from 'src/components/index';
import './error-modal.scss';

/*
  Props description:
    title=text
    body=component
    footer=component
    show=bool
*/
export default function ErrorModal(props) {
  return (
    <Modal
      modalStyle="ErrorModal"
      show={props.show}
      cardStyle="error-modal-card"
      header={() => <h5 className="heading-five has-text-centered">{props.title}</h5>}
      headerStyle="error-modal-card-head"
      body={() => props.body()}
      bodyStyle="error-modal-card-body has-text-centered"
      footer={() => props.footer()}
      footerStyle="error-modal-card-foot"
    />
  );
}
